import React from 'react';
import { createRoot } from 'react-dom/client';
import configureStore, { history } from './configureStore';
import Main from './main';

const store = configureStore();

const root = createRoot(document.getElementById('root'));
root.render(<Main store={store} history={history} />);
